import React from "react";
import headerStyles from "../../css/Part1.module.css";
import mainSectionStyles from "../../css/Part.module.css";

const CommunityRewardApp = () => {
  return (
    <div>
      <div className={headerStyles.backgroundWrapper} id="AboutUs">
        <img
          src="images/background/Home ECE9E5 Background.png"
          alt="background"
          className={headerStyles.backgroundImage}
        />
        <div className={headerStyles.content}>
              <div className={headerStyles.textbox}>
                <h1 className={headerStyles.text1}>Community</h1>
                <h1 className={headerStyles.text1}>Hyper</h1>
                <h1 className={headerStyles.text1}>Reward App</h1>
                <p className={headerStyles.text2}>
                  <strong>Fone App</strong> is a hyper reward app that turns your
                  community's daily natural spending into rewards
                  for you with our recycling program,
                  Many-To-One (M2O)
                </p>

                <a
                href="https://shop.forestone.com.my/link/referral?ReferralID=foneappmy"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className={headerStyles.signUpButton}>SIGN UP</button>
              </a>
              </div>
            <img
              src="images/background/Group 110.png"
              alt="front"
              className={headerStyles.frontimage}
            />
        </div>
      </div>
      

      {/* Main Section */}
      <div className={mainSectionStyles.backgroundWrapper1}>
        <picture>
          <source
            media="(max-width: 500px)"
            srcSet="images/background/mobilegreenbackground.png"
          />
          
          <img
            src="images/background/Background Home Green.png"
            alt="background"
            className={mainSectionStyles.backgroundImage1}
          />
        </picture>
        
        <div className={mainSectionStyles.content1}>
          <section>
            <div>
              <div className={mainSectionStyles.customRow1}>
                <div className="col-lg-6 col-12">
                  <img
                    src="images/background/Recycle Faces2.png"
                    alt="App features showcase"
                    className={mainSectionStyles.mainImage1}
                  />
                </div>
                <div className="col-lg-6 col-12">
                  <h2 className={mainSectionStyles.title1}>
                    One App at a time Community Hyper Reward App
                  </h2>
                  <p className={mainSectionStyles.description1}>
                    Turns your community's daily natural spending into rewards
                    for you with our recycling program, Many-To-One (M2O). Get
                    the best deals with our merchants, save more with our
                    campaigns & earn rewards everyday.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CommunityRewardApp;
